<template>
  <div class="dashboard-overview">
    <div class="overview-header">
      <h2 class="overview-title">{{ title }}</h2>
      <p class="overview-description">{{ description }}</p>
    </div>
    
    <div v-if="loading" class="loading-state">
      <p class="loading-text">Loading dashboards...</p>
    </div>
    
    <div v-else-if="dashboards.length === 0" class="empty-state">
      <p class="empty-text">No dashboards found</p>
    </div>
    
    <div v-else class="dashboards-grid">
      <DashboardCard
        v-for="dashboard in dashboards"
        :key="dashboard.id || dashboard.ID"
        :dashboard="dashboard"
        @click="handleCardClick(dashboard)"
        @star="handleStar(dashboard.id || dashboard.ID)"
        @menu="handleMenu(dashboard.id || dashboard.ID)"
      />
    </div>

  </div>
</template>

<script>
import DashboardCard from "./DashboardCard.vue";
import PublicDashboardItem from "./PublicDashboardItem.vue";

export default {
  name: "DashboardOverview",
  components: {
    DashboardCard,
    PublicDashboardItem,
  },
  props: {
    dashboards: {
      type: Array,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "Dashboards",
    },
    description: {
      type: String,
      default: "Here you can view and manage your existing dashboards",
    },
  },
  data() {
    return {
      publicDashboards: [
        {
          id: 101,
          title: "CCE - Oil Dashboard",
          charts: 4,
          totalCharts: 6,
        },
        {
          id: 102,
          title: "Gas Dashboard",
          charts: 4,
          totalCharts: 6,
        },
        {
          id: 103,
          title: "Sample Inventory Dashboard",
          charts: 4,
          totalCharts: 6,
        },
        {
          id: 104,
          title: "Composition Inventory Dashboard 1",
          charts: 4,
          totalCharts: 6,
        },
        {
          id: 105,
          title: "Composition Inventory Dashboard 2",
          charts: 4,
          totalCharts: 6,
        },
        {
          id: 106,
          title: "Composition Dashboard",
          charts: 4,
          totalCharts: 6,
        },
        {
          id: 107,
          title: "CCE - Oil Dashboard",
          charts: 4,
          totalCharts: 6,
        },
        {
          id: 108,
          title: "Gas Dashboard",
          charts: 4,
          totalCharts: 6,
        },
        {
          id: 109,
          title: "Sample Inventory Dashboard",
          charts: 4,
          totalCharts: 6,
        },
      ],
    };
  },
  methods: {
    handleCardClick(dashboard) {
      // Pass the full dashboard object
      this.$emit("dashboard-click", dashboard);
    },
    handleStar(dashboardId) {
      // Toggle star status
      this.$emit("star-dashboard", dashboardId);
    },
    handleMenu(dashboardId) {
      // Show menu options
      this.$emit("menu-click", dashboardId);
    },
  },
};
</script>

<style scoped>
@import '../../assets/Styling/agenticDashboard/dashboardOverview.css';
</style>

